import { axiosInstance } from ".."

const states = async (country) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`public/geolist/states/${country}?limit=300&offset=0`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default states;